import { z } from "zod";

import type { AgentManifest } from "./agents";

const STORAGE_KEY = "citrine.agents.manifest.v1";
const STORAGE_TTL_MS = 24 * 60 * 60 * 1000; // 1 day — agent list changes rarely

const agentManifestSchema = z.object({
  key: z.string(),
  label: z.string(),
  category: z.string(),
  order: z.number(),
}) satisfies z.ZodType<AgentManifest>;

const storedManifestSchema = z.object({
  savedAt: z.number(),
  agents: z.array(agentManifestSchema),
});

export function readCachedManifest(): AgentManifest[] | undefined {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return undefined;
    }

    const result = storedManifestSchema.safeParse(JSON.parse(raw));
    if (!result.success) {
      return undefined;
    }

    const isFresh = Date.now() - result.data.savedAt <= STORAGE_TTL_MS;
    return isFresh ? result.data.agents : undefined;
  } catch {
    return undefined;
  }
}

export function writeCachedManifest(agents: AgentManifest[]): void {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ savedAt: Date.now(), agents }),
    );
  } catch {
    // best-effort cache; ignore quota/private-mode failures
  }
}
